import { render, staticRenderFns } from "./TrainingCourseShow.vue?vue&type=template&id=225652ab&"
import script from "./TrainingCourseShow.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports